import styled from '@emotion/styled';

export const StyledContainer = styled.div`
  width: 100%;
`;

export const StyledBoxContainer = styled.div`
  padding: 10px 0;
  width: 100%;
  border: 1px solid #EDEDED;
  border-radius: 10px;

  
  @media screen and (max-width: ${({ theme }) =>
    theme.breakpoints?.values?.tablet + 'px'}){
      padding: 20px;
      border: none;
  };
`;
